module.exports = __webpack_public_path__ + "static/media/PDF_61.c20f7527.pdf";